<p>SET CRITERIA</p>
<div class="criteria-select-div">
  <label class="filter-text"> Criteria </label>
  <ng-select
    [items]="columns"
    bindLabel="title"
    (change)="criteriaSelected()"
    [(ngModel)]="selectedColumn"
    placeholder="- Select Criteria -"
    [clearable]="false"
    [searchable]="false"
    class="criteria-select"
    *ngIf="columns.length > 0"
  ></ng-select>
</div>
<filter-select-and-inputs
  #filterSelectAndInputs
  [isGroupCriteria]="true"
  [selectedFilterItem]="selectedFilterItem"
  [column]="selectedColumn"
  [noFilterObj]="noFilterObj"
  [betweenObj]="betweenObj"
  [equalToObj]="equalToObj"
  [greaterThanObj]="greaterThanObj"
  [lessThanObj]="lessThanObj"
  [filterItems]="filterItems"
  (minChange)="minChange($event)"
  (maxChange)="maxChange($event)"
  (singleValChange)="singleValChange($event)"
  (filterChange)="filter($event)"
>
</filter-select-and-inputs>
<button
  mat-raised-button
  (click)="addGroupCriteria()"
  class="add-criteria-btn green-btn"
  [disabled]="
    !((min != null && max != null) || singleVal != null) || !selectedColumn
  "
>
  ADD CRITERIA
</button>
